import MenuItems from './MenuItems';
import { Flex } from 'lib/ui';

export default function Navbar({ menuItems, className }: any) {
  return (
    <Flex
      className={className}
      ml={[0, null, null, 'auto']}
      pb={window.innerWidth < 960  ? [3, 'auto'] : null}
    >
      <nav>
        <ul
          sx={{
            display: 'flex',
            listStyle: 'none',
            padding: 0,
            margin: 0,
            flexDirection: ['column', null, null, 'row'],
            alignItems: ['flex-start', null, null, 'center']
          }}
        >
          {menuItems.map((menu, index) => {
            const depthLevel = 0;
            return (
              <MenuItems
                items={menu}
                key={index}
                depthLevel={depthLevel}
              />
            );
          })}
        </ul>
      </nav>
    </Flex>
  );
}
